// FormDisplay.jsx - Main component file
import React, { useEffect, useState, useRef } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { useDispatch } from "react-redux";
import DosPageSkelton from "../../skeltons/dosPageSketon";
import { useParams } from "react-router-dom";
import FieldSidebar from "./FieldSidebar";
import FormCanvas from "./FormCanvas";
import { updateFormFieldsData } from "../../../../../redux/docs/index.js";

const FormDisplay = ({ classes, formDetail, adminDetails }) => {
  const { form_id } = useParams();
  const dispatch = useDispatch();
  const [bindFieldsCount, setbindFieldsCount] = useState(0);
  const isRendered = useRef(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(null);

  const handleFieldClick = (field) => {
    setSelectedField(field);
    setSidebarOpen(true);
  };

  const handleFieldPositionUpdate = (field) => {
    console.log(field);
  };

  const handleSaveFieldChanges = () => {
    // Update formData with changes
    const updatedFormData = {
      form_id: form_id,
      field_id: selectedField.id,
      updateData: {
        instructions: selectedField.instructions,
        model_can_update: selectedField.model_can_update,
        caption: selectedField.caption,
        default_value: selectedField.default_value,
        type: selectedField.type,
      },
      handleSuccess: () => {
        setSidebarOpen(false);
      },
      handleError: () => {
        setSidebarOpen(false);
      },
    };

    dispatch(updateFormFieldsData(updatedFormData));
  };

  useEffect(() => {
    Array.from(Array(formDetail?.data?.form_fields?.length).keys()).map(
      (item) => {
        const myNode = document.getElementById(`fieldWrap${item}`);
        if (myNode) {
          myNode.innerHTML = "";
        }
      }
    );
    isRendered.current = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [form_id]);

  // console.log(selectedField, "selectedField");
  return (
    <>
      {formDetail?.data?.total_pages ? (
        Array.from(Array(formDetail?.data?.total_pages).keys())?.map(
          (index) => (
            <FormCanvas
              key={index}
              index={index}
              formDetail={formDetail}
              classes={classes}
              isRendered={isRendered}
              setbindFieldsCount={setbindFieldsCount}
              handleFieldClick={handleFieldClick}
              handleFieldPositionUpdate={handleFieldPositionUpdate}
              adminDetails={adminDetails}
            />
          )
        )
      ) : (
        <DosPageSkelton />
      )}

      <FieldSidebar
        classes={classes}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        selectedField={selectedField}
        setSelectedField={setSelectedField}
        handleSaveFieldChanges={handleSaveFieldChanges}
      />
    </>
  );
};

export default withStyles(styleSheet, { name: "FormDisplayStyle" })(
  FormDisplay
);
